import React, {useEffect, useState} from 'react';
import {
    ConfigAddressApi,
    ConfigApi,
    OrderType,
    PlaceApi,
    StoreConfigCoordinatesApi
} from "../../../../../../services/Api/types";
import MultistoreMapPageNavbar from "./Navbar/MultistoreMapPageNavbar";
import MultistoreMapPagePlaceList from "./PlaceList/MultistoreMapPagePlaceList";
import FetchPlaces from "../../../../../../components/Fetch/FetchPlaces";
import ToggleViewButton from "./ToggleViewButton";
import {usePlaceContext} from "../../../../../../services/Place/PlaceContext";
import ChangeLocationMultistoreModal from "../../../../components/ChangeLocationMultistoreModal";
import StringHelper from "../../../../../../services/Common/StringHelper";
import MultistoreMapPageGeolocationButton from "./Map/MultistoreMapPageGeolocationButton";
import OutOfDeliveryZoneInfoModal from "../../../HomePage/components/HomeWithMap/New/v1/OutOfDeliveryZoneInfoModal";

const MapComponent = React.lazy(() => import('./Map/MultistoreMapPageMap'));

interface OwnProps {
    config: ConfigApi;
}

const MultistoreMapPageComponent = ({config}: OwnProps) => {
    const BOTTOM_OFFSET = 26;
    const [view, setView] = useState<"list" | "map">("map");
    const placesContext = usePlaceContext();
    const [places, setPlaces] = useState<PlaceApi[]>(placesContext.places || []);
    const [selectedOrderType, setSelectedOrderType] = useState<OrderType | undefined>();
    const [selectedPlace, setSelectedPlace] = useState<PlaceApi | undefined>(undefined);
    const [hoveredPlace, setHoveredPlace] = useState<PlaceApi | undefined>(undefined);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [forcedCoordinatesToZoom, setForcedCoordinatesToZoom] = useState<StoreConfigCoordinatesApi | undefined>();
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);
    const [bottomOffset, setBottomOffset] = useState(BOTTOM_OFFSET);
    const [showOutOfDeliveryZoneModal, setShowOutOfDeliveryZoneModal] = useState(false);

    useEffect(() => {
        setPlaces(placesContext.places || []);
    }, [placesContext.places]);

    useEffect(() => {
        if (view === "list") {
            setBottomOffset(BOTTOM_OFFSET);
            return;
        }

        if (!selectedPlace || innerWidth > 768) return;

        const mapWrapperElement = document.querySelector(".map-wrapper");
        if (!mapWrapperElement) return;

        const card = mapWrapperElement.querySelector(".place-card") as HTMLElement;
        if (!card) return;

        const rect = card.getBoundingClientRect();
        setBottomOffset(rect.height + 16);
    }, [selectedPlace, innerWidth, view]);

    const handleHideLocationModal = (address: ConfigAddressApi) => {
        if (!StringHelper.getAddressName(address)) {
            setSelectedOrderType(undefined);
        }
        setShowAddressModal(false);
    };

    return (
        <div className="multistore-map-page multistore-page">
            <FetchPlaces>
                <MultistoreMapPageNavbar config={config} setShowAddressModal={setShowAddressModal}/>
                <div className={`inner-container ${view === "list" ? "with-list-view" : "with-map-view"}`}>
                    <MultistoreMapPagePlaceList places={places} setSelectedOrderType={setSelectedOrderType}
                                                selectedOrderType={selectedOrderType}
                                                setHoveredPlace={setHoveredPlace}
                                                setShowAddressModal={setShowAddressModal}
                                                config={config}
                                                setShowOutOfDeliveryZoneModal={setShowOutOfDeliveryZoneModal}
                    />
                    <MapComponent view={view} places={places} setSelectedOrderType={setSelectedOrderType}
                                  selectedOrderType={selectedOrderType} selectedPlace={selectedPlace}
                                  setSelectedPlace={setSelectedPlace} hoveredPlace={hoveredPlace}
                                  setShowAddressModal={setShowAddressModal} config={config}
                                  forcedCoordinatesToZoom={forcedCoordinatesToZoom}
                                  setForcedCoordinatesToZoom={setForcedCoordinatesToZoom}
                    />
                </div>
                <div className="map-buttons-container" style={{bottom: `${bottomOffset}px`}}>
                    <MultistoreMapPageGeolocationButton
                        setForcedCoordinatesToZoom={setForcedCoordinatesToZoom}
                        config={config}
                        setShowOutOfDeliveryZoneModal={setShowOutOfDeliveryZoneModal}
                    />
                    <ToggleViewButton view={view} setView={setView} setInnerWidth={setInnerWidth}/>
                </div>
                {
                    showAddressModal &&
                    <ChangeLocationMultistoreModal showModal={showAddressModal}
                                                   onHide={handleHideLocationModal}
                                                   config={config} withoutGeolocation
                                                   onChange={handleHideLocationModal}
                                                   setShowOutOfDeliveryZoneModal={setShowOutOfDeliveryZoneModal}
                    />
                }
                {
                    showOutOfDeliveryZoneModal && <OutOfDeliveryZoneInfoModal show={showOutOfDeliveryZoneModal}
                                                                              onHide={() => setShowOutOfDeliveryZoneModal(false)}
                    />
                }
            </FetchPlaces>
        </div>
    )
}

export default MultistoreMapPageComponent;